import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import styled from 'styled-components';
import Flex from '../../Flex';
import Error from '../../Error';
import { Base } from '../../Typography';
import { fontSpacingMixin } from '../../mixins/typography';
import { INPUT_FORM_BOTTOM_MARGIN } from '../../Input/constants';
import { getPx } from '../../helpers/common';
import { ExtraSmall as ExtraSmallSpacing } from '../../Typography/constants/extra-small.spacing';
import { styleArrayForBreakpoints } from '../../helpers/media-style';
import { EMPTY_PROPS } from '../../helpers';
const StyledLabel = styled(Base)`
  display: block;
  ${fontSpacingMixin(ExtraSmallSpacing)}
`;
const StyledFlex = styled(Flex)`
  position: relative;
  ${({
  $withBottomMargin
}) => styleArrayForBreakpoints([$withBottomMargin, INPUT_FORM_BOTTOM_MARGIN], ([$withBottomMargin, $value]) => $withBottomMargin ? `margin-bottom: ${getPx($value)};` : '')}
  ${({
  $withTopMargin
}) => styleArrayForBreakpoints([$withTopMargin, INPUT_FORM_BOTTOM_MARGIN], ([$withTopMargin, $value]) => $withTopMargin ? `margin-top: ${getPx($value)};` : '')}
`;
const FormItem = /*#__PURE__*/React.forwardRef(({
  fullWidth = false,
  withBottomMargin = false,
  withTopMargin = false,
  withNoPaddingForError = false,
  label,
  error,
  errorProps = EMPTY_PROPS,
  labelProps = EMPTY_PROPS,
  showError = true,
  absoluteError = false,
  visibleError = true,
  children,
  id,
  name,
  ...props
}, forwardedRef) => {
  const displayedErrorProps = useMemo(() => ({
    ...(id ? {
      'data-error-id': id
    } : {}),
    ...(name ? {
      'data-error-name': name
    } : {}),
    ...errorProps
  }), [id, name, errorProps]);
  return /*#__PURE__*/React.createElement(StyledFlex, _extends({
    ref: forwardedRef,
    direction: "ttb",
    fullWidth: fullWidth,
    $withBottomMargin: withBottomMargin,
    $withTopMargin: withTopMargin
  }, props), label && /*#__PURE__*/React.createElement(StyledLabel, _extends({
    as: "label",
    strong: true,
    withBottomMargin: true,
    htmlFor: id
  }, labelProps), label), children, /*#__PURE__*/React.createElement(Error, _extends({
    error: error,
    show: showError,
    visible: visibleError,
    absolute: absoluteError,
    noPadding: withNoPaddingForError
  }, displayedErrorProps)));
});
export default FormItem;